<template>
  <div id="Dispute">
    <div class="Textpara">
      <p class="Textaction">
        <a target="_blank" href="https://mp.weixin.qq.com/s?__biz=MzAwOTYxNTU5Nw==&mid=2649880336&idx=1&sn=a61196722e7c17cdc80f68cfdda2f28b&chksm=8359b692b42e3f84d4582162a3da307269f16fb26c9a902aaa06e73751d566b5899dc58bb07e&mpshare=1&scene=1&srcid&sharer_sharetime=1593334750671&sharer_shareid=503152027cc25764197a0b290282c5de&exportkey=ARgrZHr3UNoskdqxfsG2114%253D&pass_ticket=gxhRjxGwC%252BVHd5wSoOH86oTV4MZUcy%252F5PWlvveK8bBI%253D%23rd">
          上海市通信管理局关于开展2020年电信和互联网行业网络安全检查工作的通知
        </a>
      </p> 
    </div>
  </div>
</template>
<script>
export default {
  name: "Dispute"
};
</script>
<style lang="stylus" scoped>
@import '../Common/common.styl';
#Dispute{
  width:100%; 
  paddingPage();
  cardStyle(); 
  height:600px;
} 
</style> 


// WEBPACK FOOTER //
// src/components/About/News.vue